import { all } from 'redux-saga/effects'

export default function* usuarioWatcherSaga() {
    yield all([])
}